// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 02XBjoJRtNHq
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicOnboardingBizFail.module.css"; // plasmic-import: 02XBjoJRtNHq/css
import CheckSvgIcon from "./icons/PlasmicIcon__CheckSvg"; // plasmic-import: NNWdipNv4a0I/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: cdQ-QsSHJP16/icon

createPlasmicElementProxy;

export const PlasmicOnboardingBizFail__VariantProps = new Array();

export const PlasmicOnboardingBizFail__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingBizFail__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__kXuY)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__pbBf
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox___7QrVv)}>
            <div className={classNames(projectcss.all, sty.freeBox__ddLQm)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg___4Hi9)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__niqi)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__wXzWd)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__rCiR9)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__ezAn6)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___727U)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg___9U95I)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__eeRWo)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__tP3Y)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__sdGmQ)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___36Ebi)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__xT3Qu)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__wahzk)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__ueQvm)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__uLj3
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__zDwyI
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__opVI
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ux0Fq
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__rcO3M
                )}
              >
                {"Review & Submit"}
              </div>
            </Stack__>
            <div className={classNames(projectcss.all, sty.freeBox___4Aclr)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__sxFup
                )}
              >
                {"Application Unapproved"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__klTYy
                )}
              >
                {
                  "Unfortunately, your account has not been approved due to issues with validating your identity. "
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingBizFail__ArgProps,
          internalVariantPropNames: PlasmicOnboardingBizFail__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingBizFail__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingBizFail";
  } else {
    func.displayName = `PlasmicOnboardingBizFail.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingBizFail = Object.assign(
  // Top-level PlasmicOnboardingBizFail renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    // Metadata about props expected for PlasmicOnboardingBizFail
    internalVariantProps: PlasmicOnboardingBizFail__VariantProps,
    internalArgProps: PlasmicOnboardingBizFail__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingBizFail;
/* prettier-ignore-end */
